import PrefixEnum from '../prefixes'

export default Object.freeze({
    'perfectshape.gymondo.fitness': PrefixEnum.HARRISON,
})
